import React, { useState } from "react";
import "./main.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import Navigation from "../Navigation/index";
import Home from "../Home/index";
import About from "../About/index";
import Education from "../../components/Education/index";
import Experience from "../Experience/index";
import Services from "../Services/index";
import Portfolio from "../Portfolio/index";
import Testimonial from "../Testimonial/index";
import Contact from "../Contact/index";
import Footer from "../Footer/index";
const Main = () => {
  const [toogle, setToogle] = useState(false);
  return (
    <div className="container">
      <div className="toogle">
        <span onClick={() => setToogle(!toogle)}>
          <div className="toogleNav">
            {toogle ? (
              <MdClose color="white" className="closeToogle" />
            ) : (
              <GiHamburgerMenu color="white" className="openToogle" />
            )}
          </div>
        </span>
        {toogle ? (
          <div className="sideBarr">
            <Navigation />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="sideBar">
        <Navigation />
      </div>
      <div className="mainSection">
        <div className="landingSection" id="home">
          <Home />
        </div>
        <div className="aboutSection" id="about">
          <About />
        </div>
        <div className="educationSection">
          <Education />
        </div>
        <div className="experienceSection">
          <Experience />
        </div>
        <div className="servicesSection" id="services">
          <Services />
        </div>
        <div className="portfolioSection" id="portfolio">
          <Portfolio />
        </div>
        <div className="testimonialSection" id="testimonial">
          <Testimonial />
        </div>
        <div className="contactSection" id="contact">
          <Contact />
        </div>
        <div className="footerSection">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Main;
